import React from 'react';
import react from '../assets/icons/react.svg'
import python from '../assets/icons/python.svg'
import Bar from './Bar';

const languages = [
    {
        icon: python,
        name: 'Python',
        level: '70'
    },
    {
        icon: react,
        name: 'React',
        level: '90'
    },
    {
        icon: react,
        name: 'React Router/Redux',
        level: '90'
    },
    {
        icon: react,
        name: 'JavaScript',
        level: '85'
    },
    {
        icon: react,
        name: 'HTML/CSS',
        level: '85'
    },
    {
        icon: react,
        name: 'PHP',
        level: '80'
    }
]

const tools = [
    {
        icon: react,
        name: 'Node.js',
        level: '85'
    },
    {
        icon: react,
        name: 'Github',
        level: '90'
    },
    {
        icon: react,
        name: 'RestfulAPI',
        level: '70'
    },
    {
        icon: react,
        name: 'TypeScript',
        level: '77'
    },
    {
        icon: react,
        name: 'ES6',
        level: '80'
    },

]


const Resume = () => {
    return (
        <div className="container resume">
            <div className="row">
                <div className="col-lg-6 resume-card" >
                    <h4 className="resume-card__heading">
                        Education
                    </h4>
                    <div className="resume-card__body">
                        <h5 className="resume-card__title">
                            Computer Science 
                        </h5>
                        <p className="resume-card__name">
                            Master in Computer Science(2019-2020)
                        </p>
                        <p className="resume-card__details">I have done Master of Information and Communication Technology</p>
                    </div>
                </div>
                <div className="col-lg-6 resume-card" >
                    <h4 className="resume-card__heading">
                        Experience
                    </h4>
                    <div className="resume-card__body">
                        <h5 className="resume-card__title">
                            Reesby (React Developer)
                        </h5>
                        <p className="resume-card__name">
                           Jan2021 - Apr2021 Reesby 
                        </p>
                        <p className="resume-card__details">Working with a team of engineers on a CRM Project using AI / Machine Learning which uses python on the backend. Also working on a Web-based CRM which is Java-based (Back end) Website, and React (Front end), AWS, TypeScript, MongoDB, Node+, etc.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 resume-languages">
                    <h5 className="reume-language__heading">
                        Language and Framework
                    </h5>
                    <div className="resume-language__body mt-3">
                        {
                            languages.map(language =>
                                <Bar value={language} />
                            )
                        }
                    </div>
                </div>
                <div className="col-lg-6 resume-languages">
                    <h5 className="reume-language__heading">
                        Tools and Softwares
                    </h5>
                    <div className="resume-language__body mt-3">
                        {
                            tools.map(tool => <Bar value={tool} />)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resume;